import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error("Enter email and password."); return; }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      if (data.token) localStorage.setItem("ng_admin_token", data.token);
      toast.success("Logged in");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center pt-20 pb-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm px-4"
      >
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-[#FF5722]/10 flex items-center justify-center mx-auto mb-4">
            <Lock size={24} className="text-[#FF5722]" />
          </div>
          <h1 className="text-2xl font-bold" style={{ fontFamily: "'Clash Display', sans-serif" }}>Admin Login</h1>
          <p className="text-sm text-[#A3A3A3] mt-2">Access the NG Industries dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label className="text-sm text-[#A3A3A3] mb-2 block">Email</Label>
            <Input
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@ngindustries.com.au"
              className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
            />
          </div>
          <div>
            <Label className="text-sm text-[#A3A3A3] mb-2 block">Password</Label>
            <Input
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
            />
          </div>
          <button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-[#FF5722] text-white py-3 font-semibold text-sm hover:bg-[#E64A19] transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in..." : <><span>Sign In</span><ArrowRight size={16} /></>}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
